module.exports = __webpack_public_path__ + "img/wlhz.2721547f.png";